var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26878 20.8757H5.62742C5.40303 20.8757 5.18784 20.7865 5.02917 20.6279C4.87051 20.4692 4.78137 20.254 4.78137 20.0296V19.1519C4.78137 16.7051 3.83804 14.362 2.19291 12.7219C1.14809 11.682 0.435522 10.3552 0.145504 8.90989C-0.144514 7.46453 0.00107437 5.9656 0.56382 4.60307C1.12656 3.24054 2.08113 2.07574 3.30656 1.25628C4.53198 0.436818 5.97309 -0.000410916 7.44725 2.89781e-07H7.48448C8.95831 0.00632197 10.3971 0.449933 11.6186 1.27464C12.8401 2.09935 13.7893 3.26804 14.3461 4.63268C14.9028 5.99732 15.042 7.49649 14.746 8.9403C14.45 10.3841 13.7322 11.7076 12.6834 12.7431C11.0501 14.3573 10.1136 16.6696 10.1136 19.0884V20.0313C10.1136 20.2557 10.0244 20.4709 9.86576 20.6296C9.70709 20.7882 9.4919 20.8774 9.26751 20.8774L9.26878 20.8757Z",
    fill: "#684FFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedLearn);
export default __webpack_public_path__ + "static/media/selectedLearn.67b2011b92bfd8567fb47021116c0602.svg";
export { ForwardRef as ReactComponent };